import { defaults } from './defaults';
export const environment = {
  ...defaults,
  production: true
};
